var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{attrs:{"title":((_vm.$t('common.services.singular')) + " " + (_vm.$t('common.details.plural')))},scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('service-detail')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }